import { FormHandles } from '@unform/core';
import { useRef } from 'react';

export const useVFormRef = () => useRef<FormHandles>(null);
